import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import axios from 'axios'
import {i18n} from './i18n'

Vue.config.productionTip = false;
Vue.use({
  install (Vue) {
  Vue.prototype.$api = axios.create({
    
  })
}
})
new Vue({
  el: '#app',
  i18n,
  store, 
  render: h => h(App),
}).$mount('#app')
